/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPushButtonCellphone: {
  name: 'push-button-cellphone';
  data: string;
} = {
  name: 'push-button-cellphone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 1a.5.5 0 0 0-1 0v2.5H5A1.5 1.5 0 0 0 3.5 5v9A1.5 1.5 0 0 0 5 15.5h6a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 11 3.5H6.5V1ZM5 4.5a.5.5 0 0 0-.5.5v2.5h7V5a.5.5 0 0 0-.5-.5H5Zm6.5 4h-7V14a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V8.5Zm-1.5 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM9.5 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM7 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM6.5 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></svg>`,
};
